import { Link, useLocation } from "react-router-dom";
import { Lock } from "lucide-react";

export const Header = () => {
  const { pathname } = useLocation();
  const nav = [
    { label: "Lookbook", to: "/" },
    { label: "Products", to: "/products" },
  ];
  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0B0B0C]/80 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="group" data-testid="nav-logo">
          <span className="font-serif text-2xl tracking-[0.35em] text-[#F8F6F0] group-hover:text-[#D4AF37] transition-colors duration-300">
            LUXBEL
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-12">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}-link`}
              className={`overline hover:text-[#D4AF37] transition-colors duration-300 ${
                pathname === n.to ? "text-[#D4AF37]" : ""
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <Link
          to="/admin"
          data-testid="nav-admin-portal-link"
          className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] px-4 py-2 border border-white/15 rounded-full hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300"
        >
          <Lock size={13} /> Team
        </Link>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer className="border-t border-white/10 mt-32 py-16 px-6 lg:px-12" data-testid="site-footer">
    <div className="max-w-[1500px] mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
      <div>
        <div className="font-serif text-3xl tracking-[0.35em] text-[#F8F6F0]">LUXBEL</div>
        <p className="overline mt-4">Video Lookbook · theluxbel.com</p>
      </div>
      <p className="text-[#8E8E9A] text-sm max-w-sm font-light leading-relaxed">
        A curated editorial catalogue built from film. Every product traced from motion, refined by hand.
      </p>
    </div>
  </footer>
);
